import { useEffect, useRef } from "react";
import { trackEvent } from "../../lib/analytics";

// Dispara un evento "section_view" en GA4 la primera vez que la sección
// entra al viewport (al menos 40% visible). Se envía una sola vez por carga de página.
export default function useSectionView(sectionName) {
  const ref = useRef(null);
  const tracked = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || tracked.current) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !tracked.current) {
          tracked.current = true;
          trackEvent("section_view", { section_name: sectionName });
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [sectionName]);

  return ref;
}
